import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";
import { useState } from "react";
import Loader from "react-loader-spinner";
import "react-phone-input-2/lib/style.css";

import { toastMessage } from "../../../utils/toast";
import * as userActions from "../../../Redux/Actions/user";

export default function ForgotPasswordModal({
  showModal,
  history,
  loading,
  handleCancel,
  footerOption1,
  footerOption2,
  t,
}) {
  const [errMsg, setErrMsg] = useState("");
  const [email, setEmail] = useState("");
  const [buttonLoading, setButtonLoading] = useState("");

  const handleOk = () => {
    setButtonLoading(true);
    if (email !== "") {
      // toastMessage('error', `Enter the correct details`);
      const payload = {
        userName: email,
      };
      userActions
        .userForgotPassword(payload)
        .then((res) => {
          if (res && res.status === 200) {
            toastMessage("success", res.data.message);
            history.push(`/`);
            setButtonLoading(false);
          } else {
            toastMessage("error", "Enter Correct Email Id or Phone Number");
          }
        })
        .catch((err) => {
          toastMessage("error", "User Not Found");
          setButtonLoading(false);
        });
    } else {
      setErrMsg("Please enter Email or Phone Number");
      setButtonLoading(false);
    }
  };

  return (
    <div>
      <div
        className="modal"
        style={{ display: showModal ? "block" : "", top: "50%" }}
      >
        <div className="modal-dialog" style={{ maxWidth: "600px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 style={{ color: "white" }}></h5>
              <button
                type="button"
                className="close p-1 rounded"
                aria-label="Close"
                onClick={handleCancel}
                style={{ border: "none" }}
              >
                <MdClose />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center">
                <label className="p-3 form-label font-15">User Name</label>
                <input
                  type="email"
                  className="p-1 form-control"
                  required={true}
                  style={{ marginLeft: "85px", width: "53%", height: "30px" }}
                  placeholder="Enter Email / Phone"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrMsg("");
                  }}
                ></input>
              </div>
            </div>

            {errMsg && <p className="text-danger text-center">{errMsg}</p>}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light-danger font-weight-bold"
                onClick={handleCancel}
              >
                {footerOption2 ? footerOption2 : "Cancel"}
              </button>
              <button
                type="button"
                className="btn btn-primary font-weight-bold d-flex align-items-center"
                onClick={handleOk}
                disabled={buttonLoading}
              >
                {footerOption1 ? footerOption1 : "Submit"}
                {buttonLoading && (
                  <Loader
                    type="Oval"
                    color="#fff"
                    height={20}
                    width={20}
                    style={{ marginLeft: "10px" }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
    </div>
  );
}
